import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { CUSTOM_LINE_FRAGMENT } from 'graphql/fragments/custom-line';
import { PRODUCT_LINE_FILTERED_VARIABLES_FRAGMENT } from 'graphql/fragments/filtered-variables';
import { PRODUCT_LINE_WITHOUT_PRICING_FRAGMENT } from 'graphql/fragments/product-line';
import { PRODUCT_LINE_PRICING_FRAGMENT } from 'graphql/fragments/product-line-pricing';
import { PRODUCT_LINE_PRODUCT_FRAGMENT } from 'graphql/fragments/product-line-product';
import { PRODUCT_LINE_VARIABLES_FRAGMENT } from 'graphql/fragments/product-line-variables';
import { PRODUCT_LINE_CONFIGURATION_FILTERS_FRAGMENT } from 'graphql/fragments/filters-configuration-section';
import { Query as RootQuery } from 'graphql/models/generated';

export const PRODUCT_POSITION_QUERY = gql`
  query productLine(
    $documentVersion: DocumentVersionInput!,
    $lineId: String!
    $withVariables: Boolean!
    $withPricing: Boolean!
  ) {
    quotes {
      quote(documentVersion: $documentVersion) {
        line(id: $lineId) {
          ...ProductLinePricingFragment @include(if: $withPricing)
          ...ProductLineWithoutPricingFragment
          ...ProductLineProductFragment
          ...ProductLineVariablesFragment @include(if: $withVariables)
          ...ProductLineFilteredVariablesFragment @include(if: $withVariables)
          ...ProductLineConfigurationFiltersFragment @include(if: $withVariables)
          ...CustomLineFragment
        }
      }
    }
  }
  ${PRODUCT_LINE_WITHOUT_PRICING_FRAGMENT}
  ${PRODUCT_LINE_PRICING_FRAGMENT}
  ${PRODUCT_LINE_PRODUCT_FRAGMENT}
  ${PRODUCT_LINE_VARIABLES_FRAGMENT}
  ${PRODUCT_LINE_FILTERED_VARIABLES_FRAGMENT}
  ${CUSTOM_LINE_FRAGMENT}
  ${PRODUCT_LINE_CONFIGURATION_FILTERS_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class ProductPositionQuery extends Query<RootQuery> {
  document = PRODUCT_POSITION_QUERY;
}
